module.exports = __webpack_public_path__ + "assets/img/sixth_user_s.4db7efed.svg";